import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ImgPointsForts9 from '../../../src/Assets/ImgPointsForts9.jpg';
import Rectangle_1 from '../../../src/Assets/QuiSommesNs/Rectangle_1.png';
import Rectangle_2 from '../../../src/Assets/QuiSommesNs/Rectangle_2.png';
import Rectangle_3 from '../../../src/Assets/QuiSommesNs/Rectangle_3.png';
import Rectangle_4 from '../../../src/Assets/QuiSommesNs/Rectangle_4.png';
import Rectangle_5 from '../../../src/Assets/QuiSommesNs/Rectangle_5.png';
import Rectangle_6 from '../../../src/Assets/QuiSommesNs/Rectangle_6.png';
import Rectangle_7 from '../../../src/Assets/QuiSommesNs/Rectangle_7.png';
import {buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
import {DrawImageHomeExpert26, DrawImageHomeExpert27, DrawImageHomeExpert28, DrawImageHomeExpert29, DrawImageHomeExpert30, DrawImageHomeExpert31, DrawImageHomeExpert32, DrawImageHomeExpert33, DrawImageHomeExpert34 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';

function QuiSommesNs() {

    const {device}=useWindowSize();
    const navigate=useNavigate();
    const { i18n } = useTranslation();
    usePersistedLanguage();

    return (

        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width:'100%',background:'white',height:'fit-content'}}>
                <NavbarConsulting />
                {device=='desktop' &&
                <div className='homeExpertf21'>
                    <a
                        href="#apropos"
                        className='homeExpertf22'
                    >{i18n.t('A propos')}</a>
                    <a
                        href="#QsommesNs"
                        className='homeExpertf22'
                    >{i18n.t('Qui sommes nous')}</a>
                    <a
                        href="#Nvaleurs"
                        className='homeExpertf22'
                    >{i18n.t('Nos valeurs')}</a>
                    <a
                        href="#Nequipe"
                        className='homeExpertf22'
                    >{i18n.t('Notre équipe')}</a>

                </div>
                }
                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch'}}>
                    <div
                        className='frame105HomePage'
                        id='apropos'
                        style={{width:'90%',height:'auto'}}
                    >
                        <div className='frame106HomePage'>
                            <div
                                className='frame107HomePage'
                                style={{width:device=='desktop'?'55%':'100%'}}
                            >
                                <div className='frame108HomePage'>
                                    <p className='homeExpertf53'>{i18n.t('à propos')}</p>
                                    <h3 className='frame101HomePage'>
                                        {i18n.t('HTH connecte les entreprises avec les meilleurs Experts freelances')}
                                    </h3>
                                    <h6 className='frame110HomePage'>
                                        {i18n.t('Notre mission est d\'accompagner nos clients dans la recherche de profils qualifiés pour la réalisation de leurs projets, tout en offrant aux experts l\'opportunité de booster leur carrière en trouvant les missions qui correspondent à leurs compétences et leur permettent d\'évoluer.')}
                                    </h6>
                                </div>

                            </div>
                            <div
                                className='frame112HomePage'
                                style={{width:device=='desktop'?'45%':'100%'}}
                            >
                                <DrawImageHomeExpert27 width={device=='desktop'?'453':'330'}/>
                            </div>

                        </div>
                    </div>
                    <div
                        className='frame105HomePage'
                        id='apropos'
                        style={{width:'90%',height:'auto'}}
                    >
                        <div
                            className='frame106HomePage'
                            style={{background:'#F8F9FA',borderRadius:'20px',padding: '24px'}}
                        >
                            <div
                                className='frame107HomePage'
                                style={{width:device=='desktop'?'65%':'100%'}}
                            >
                                <div className='frame108HomePage'>
                                    <h4 className='frame101HomePage'>
                                        {i18n.t('L\'incroyable Histoire')}
                                    </h4>
                                    {device!='desktop' &&
                                        <div
                                            className='frame112HomePage'
                                            style={{width:device=='desktop'?'35%':'100%'}}
                                        >
                                            <img
                                                src={ImgPointsForts9}
                                                width='100%'
                                                height='488px'
                                                style={{borderRadius:'20px'}}
                                            />
                                        </div>
                                    }
                                    <h6
                                        className='frame110HomePage'
                                        style={{textAlign:'left'}}
                                    >
                                        {i18n.t('High Tech Hires dépasse le simple rôle d\'une plateforme digitale de sourcing. Notre objectif est d\'offrir un soutien complet aux entreprises dans leur processus de recrutement de freelances, tout en aidant les freelances à trouver des projets à fort potentiel pour stimuler leur carrière.Nous nous positionnons comme la première plateforme où les professionnels se connectent et collaborent, dans un environnement qui garantit flexibilité, transparence et sécurité. Notre priorité est de veiller au meilleur intérêt de notre clientèle. Depuis 2003, nous sommes activement présents dans cette industrie et avons acquis une connaissance approfondie des besoins de nos clients et des indépendants. Grâce à cette expertise, nous avons développé une plateforme intelligente spécialement conçue pour répondre aux besoins de chacun.Chez High Tech Hires, nous croyons en l\'importance de la technologie pour simplifier et optimiser le processus de mise en relation entre les entreprises et les freelances. Nous nous engageons à fournir des services de qualité supérieure et à être un partenaire de confiance pour nos clients et nos freelances.')}
                                    </h6>
                                </div>
                            </div>
                            {device=='desktop' &&
                            <div
                                className='frame112HomePage'
                                style={{width:device=='desktop'?'35%':'100%'}}
                            >
                                <img
                                    src={ImgPointsForts9}
                                    width='415px'
                                    height='488px'
                                    style={{borderRadius:'20px'}}
                                />
                            </div>
                            }

                        </div>
                    </div>

                    <div
                        className='homeExpertf46'
                        id='QsommesNs'
                    >
                        <div className='homeExpertf47'>
                            <DrawImageHomeExpert28 />
                            <div className='homeExpertf48'>
                                <h5 className='homeExpertf16'>
                                    {i18n.t('Notre Mission')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Faciliter la mise en relation des entreprises avec les meilleurs indépendants et garantir un suivi continu tout au long de leurs projets, le tout sur une plateforme unique.')}                               </p>
                            </div>
                        </div>

                        <div
                            className='homeExpertf47'
                            style={{background:'#E7EAF9'}}
                        >
                            <DrawImageHomeExpert29 />
                            <div className='homeExpertf48'>
                                <h5 className='homeExpertf16'>
                                    {i18n.t('Notre Vision')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Être à l\'avant-garde des nouvelles technologies en proposant un processus entièrement numérisé et des solutions intelligentes pour répondre aux besoins de tous les utilisateurs de manière optimale.')}                                </p>

                            </div>
                        </div>

                        <div className='homeExpertf47'>
                            <DrawImageHomeExpert30 />
                            <div className='homeExpertf48'>

                                <h5 className='homeExpertf16'>
                                    {i18n.t('Notre Ambition')}
                                </h5>
                                <p className='homeExpertf49'>
                                    {i18n.t('Notre aspiration est de développer une plateforme universelle de premier plan, en mettant l\'accent sur notre mérite et notre quête d\'excellence.')}                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        className='homeExpertf18'
                        id='Nvaleurs'
                    >
                        <h2 className='homeExpertf50'>{i18n.t('Nos Valeurs')} </h2>
                        <div
                            className='homeExpertf45'
                            style={{padding:'0px'}}
                        >
                            <div
                                className='homeExpertf51'
                                style={{
                                    display: 'grid',
                                    flex: '1 1 0%',
                                    gridTemplateColumns: device=='desktop'?'repeat(2, minmax(0, 1fr))':'repeat(1, minmax(0, 1fr))',
                                    //background: '#F8F9FA',
                                    //borderBottom: '1px solid #C3C9F1',
                                    height: 'fit-content',
                                    width:'100%',
                                }}
                            >
                                <div className='homeExpertf52'>
                                    <DrawImageHomeExpert31 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Innovation')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous combinons audace et innovation pour une amélioration continue apte à créer de la valeur, avec et pour nos clients. Nous croyons fermement que cette capacité à oser, innover et proposer fera toute la différence.')}
                                        </p>
                                    </div>
                                </div>

                                <div
                                    className='homeExpertf52'
                                    style={{background:'#E3F5EA'}}
                                >
                                    <DrawImageHomeExpert32 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Excellence')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous visons l\'excellence dans tout ce que nous entreprenons pour satisfaire au mieux nos clients et nos freelances. C\'est ainsi que nous favorisons un environnement de collaboration et de soutien mutuel.')}
                                        </p>
                                    </div>
                                </div>

                            </div>

                            <div
                                className='homeExpertf51'
                                style={{
                                    display: 'grid',
                                    flex: '1 1 0%',
                                    gridTemplateColumns: device=='desktop'?'repeat(2, minmax(0, 1fr))':'repeat(1, minmax(0, 1fr))',
                                    //background: '#F8F9FA',
                                    //borderBottom: '1px solid #C3C9F1',
                                    height: 'fit-content',
                                    width:'100%',
                                }}
                            >
                                <div
                                    className='homeExpertf52'
                                    style={{background:'#E3F5EA'}}
                                >
                                    <DrawImageHomeExpert33 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Confiance')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous sommes convaincus qu\'une communication ouverte et honnête constitue la meilleure fondation pour toute relation. C\'est ainsi que nous établissons des relations de confiance durables.')}
                                        </p>
                                    </div>
                                </div>

                                <div className='homeExpertf52'>
                                    <DrawImageHomeExpert34 />
                                    <div className='homeExpertf48'>
                                        <h5 className='homeExpertf16'>
                                            {i18n.t('Intégrité')}
                                        </h5>
                                        <p className='homeExpertf49'>
                                            {i18n.t('Nous faisons preuve d\'intégrité et de respect dans nos actions. Nous assumons pleinement nos engagements et nos responsabilités, en accord avec nos déclarations.')}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div
                        id='Nequipe'
                        className='homeExpertf18'
                        style={{width:device=='desktop'?'64%':'94%'}}
                    >
                        <h2 className='homeExpertf50'>{i18n.t('Notre Equipe')} </h2>
                        <div
                            className='homeExpertf45'
                            style={{padding:'0px'}}
                        >
                            <div style={{display:'flex',flexDirection:'row',gap:'24px'}}>
                                <div style={{display:'flex',flexDirection:'column',gap:'24px'}}>
                                    <img src={Rectangle_1} />
                                    <img src={Rectangle_2} />
                                    <img src={Rectangle_3} />
                                </div>
                                <div style={{display:'flex',flexDirection:'column',gap:'24px'}}>
                                    <img src={Rectangle_4} />
                                    <img src={Rectangle_5} />
                                </div>
                                {device=='desktop' &&
                                <div style={{display:'flex',flexDirection:'column',gap:'24px'}}>
                                    <img src={Rectangle_6} />
                                    <img src={Rectangle_7} />
                                </div>
                                }
                            </div>
                        </div>
                        <h6
                            className='frame110HomePage'
                            style={{textAlign:'left'}}
                        >
                            {i18n.t('Notre équipe dispose d\'une expérience de longue date dans le conseil et le recrutement dans les technologies de l\'information, ce qui nous permet de concevoir et de mettre en œuvre des solutions intelligentes et gagnantes pour tous. Guidés par nos valeurs fondamentales, nous sommes une équipe dévouée, passionnée et déterminée. Notre force réside dans la force et l\'union de notre équipe. Chez High Tech Hires, nous croyons en l\'esprit d\'équipe et en l\'intelligence collective qui nous mènent vers le succès. Nous apprenons et grandissons ensemble dans notre quête constante d\'excellence.')}
                        </h6>
                    </div>

                    <div className='homeExpertf44'>
                        <div className='homeExpertf45'>
                            <h3 className='frame101HomePage'>
                                {i18n.t('Prêt à nous rejoindre et à adopter notre solution')}
                            </h3>
                            {device!='desktop' &&
                            <DrawImageHomeExpert26 />
                            }
                            <Button
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onClick={()=>{
                                    navigate('/register');
                                }}
                            >
                                {i18n.t('S\'inscrire')}
                            </Button>
                        </div>
                        {device=='desktop' &&
                        <DrawImageHomeExpert26 />
                        }
                    </div>

                </div>
                <Footer />
            </div>
        </>
    );
}

export default QuiSommesNs;